import React from 'react';
import './Sections.scss';

function Section1() {
  return (
    <section className="sections sections-section1">
      <p className="sections-copy">
        For generations, home ownership has been a steady way to generate wealth. Of course, past
        performance is no guarantee of future results and prices have declined in some years, but
        most homes have consistently appreciated in value over the long-term.
      </p>
      <p className="sections-copy">
        In fact, the financial benefits of home ownership are clear from the staggering difference
        in total household wealth between homeowners and renters. In 2021, homeowners had an average
        net worth of close to $300,000, whereas that figure is approximately $8,000 for renters. For
        most middle-class families, rising home prices explain much of the wealth gap between
        homeowners and renters.
      </p>
      <p className="sections-copy">
        But it’s not just rising real estate values that give homeowners an edge when it comes to
        building wealth. Homeowners also have the advantage over renters when it comes to
        withstanding inflation, building equity, and accessing tax advantages.
      </p>
    </section>
  );
}

export default Section1;
